import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setPrescriptionHome} from "../../../../_reducers/DataPanel/Prescription/prescriptionSlice";
import {Col, ProgressBar, Row} from "react-bootstrap";
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import moment from "moment";
import Button from "react-bootstrap/Button";
import DHPCMessagesModal from "./Components/dhpcMessagesModal";

const PrescriptionHome = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const prescriptionHome = useSelector((state) => state.PRESCRIPTION.prescriptionHome);
    const noInnProgress = prescriptionHome.totalNoInnValue / prescriptionHome.totalValue * 100 || 0;

    const [showDHPCMessages, setShowDHPCMessages] = useState(false);

    useEffect(() => {
        if (prescriptionHome.firstLoad) {
            dispatch(setPrescriptionHome({...prescriptionHome, firstLoad: false}));
            fetchPrescriptionHome();
        }
    }, [])

    const fetchPrescriptionHome = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/prescription/prescription-home`, {
            headers: { 'Content-Type': 'application/json' },
            params: {
                company: company.id,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setPrescriptionHome({...prescriptionHome, ...res.data.data}));
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            <Row className={"mb-2"}>
                <Col md={7}>
                    <div className={"borderedContainer"}>
                        <div style={{position: "relative"}}>
                            <strong>Συνταγογράφηση με Εμπορική Ονομασία</strong>{"  "}({prescriptionHome.totalNoInnValue} € / {prescriptionHome.totalValue} €) - {Number(noInnProgress).toFixed(1)}%
                            <ProgressBar className={"mb-2"} variant={noInnProgress < 90 ? "info" : "danger"} striped now={noInnProgress} style={{height: "20px", textAlign: "center"}}/>
                            <div>
                                Ποσοστό αξίας συνταγογραφημένων σκευασμάτων με εμπορική ονομασία επί του συνόλου: <strong>{Number(noInnProgress).toFixed(1)}%</strong><br/>
                                Συνολική αξία συνταγογραφημένων σκευασμάτων με εμπορική ονομασία: <strong>{prescriptionHome.totalNoInnValue}€</strong><br/>
                                Συνολική αξία συνταγογραφημένων σκευασμάτων: <strong>{prescriptionHome.totalValue}€</strong><br/>
                                <Alert variant={"secondary"} className={"mt-1 mb-1"}>
                                    Το ποσοστό της συνολικής αξίας των συνταγογραφημένων σκευασμάτων με εμπορική ονομασία δεν θα πρέπει να υπερβαίνει το 15% της συνολικής αξίας των συνταγογραφημένων σκευασμάτων σε ετήσια βάση.
                                </Alert>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col md={5}>
                    <Button style={{width: "100%"}} className={"mb-1"} size={"sm"} onClick={() => setShowDHPCMessages(true)}>
                        Ενημερώσεις προς Επαγγελματίες Υγείας
                    </Button>
                    <div className={"borderedContainer"}>
                        <div style={{fontSize: "20px"}}>
                            Όριο μηνιαίας φαρμ. δαπάνης ΕΟΠΥΥ ανά ασφ/νο: <br/>
                            <div style={{textAlign: "center"}}><strong>{prescriptionHome.eoppyCostLimit} €</strong></div>
                            Τρέχουσα μηνιαία φαρμ. δαπάνη ανά ασφ/νο: <br/>
                            <div style={{textAlign: "center"}}><strong>{prescriptionHome.actualCost} €</strong></div>
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={7}>
                    <div className={"borderedContainer"}>
                        <h5>Ανακοινώσεις</h5>
                        <div style={{maxHeight: "40vh", overflowY: "auto"}}>
                            {prescriptionHome.announcements.map((ann, idx) => (
                                <div>
                                    <span dangerouslySetInnerHTML={{__html: ann.announcement}}></span>
                                    {prescriptionHome.announcements.length - 1 !== idx && (
                                        <hr/>
                                    )}
                                    <div className={"text-muted"} style={{textAlign: "right"}}><i>{moment(ann.startDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")}</i></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </Col>
            </Row>

            <DHPCMessagesModal
                show={showDHPCMessages}
                setShow={setShowDHPCMessages}
            />
        </React.Fragment>
    )
}

export default PrescriptionHome
